var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-empty"},[_c('div',{staticClass:"empty-bg",class:[_vm.emptyStatus.class]}),_c('p',{staticClass:"msg"},[_vm._v(_vm._s(_vm.emptyStatus.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }